import { CACHE_PREFIX } from '../const/caches'

declare global {
  interface Window {
    _use_access_handle_?: boolean
    _localStorage?: Storage
  }
}

export class CacheStorageProxy {
  private prefix: string

  constructor(prefix: string) {
    this.prefix = prefix
  }

  /**
   * 设置存储句柄
   */
  public async setAccessHandle() {
    if (window['_use_access_handle_']) return
    if (!document.hasStorageAccess || !document.requestStorageAccess) return

    try {
      const hasAccess = await document.hasStorageAccess()
      if (!hasAccess) return
      // @ts-ignore
      const h: any = await document.requestStorageAccess({ localStorage: true })
      // @ts-ignore
      if (h?.localStorage) {
        // console.log('set access handle.', h.localStorage)

        Object.defineProperty(window, 'localStorage', {
          value: h.localStorage,
        })
        window['_localStorage'] = h.localStorage
        window['_use_access_handle_'] = true
      }
    } catch (error) {
      console.error('setAccessHandle error :>> ', error)
    }
  }

  private getKey(key: string): string {
    return `${this.prefix}:${key}`
  }

  setItem(key: string, value: any): void {
    try {
      localStorage.setItem(this.getKey(key), JSON.stringify(value))
    } catch (error) {
      console.error('setItem error :>> ', error)
    }
  }

  getItem<T = any>(key: string): T | null {
    try {
      const value: string | null = localStorage.getItem(this.getKey(key))
      if (!value) return null
      return JSON.parse(value) as T
    } catch (error) {
      console.error('getItem error :>> ', error)
      return null
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(this.getKey(key))
    } catch (error) {
      console.error('removeItem error :>> ', error)
    }
  }

  clear(): void {
    try {
      const keys = Object.keys(localStorage)
      keys.forEach((key) => {
        if (key.startsWith(this.prefix + ':')) {
          localStorage.removeItem(key)
        }
      })
    } catch (error) {
      console.error('clear error :>> ', error)
    }
  }

  getAllKeys(): string[] {
    try {
      return Object.keys(localStorage)
        .filter((key) => key.startsWith(this.prefix + ':'))
        .map((key) => key.slice(this.prefix.length + 1))
    } catch (error) {
      console.error('getAllKeys error :>> ', error)
      return []
    }
  }

  /**
   * 监听缓存变化
   * @param key 缓存key
   * @param callback 回调函数
   * @returns 取消监听函数
   */
  watch(key: string, callback: (value: any) => void) {
    const watchKey = this.getKey(key)
    const handler = (e: StorageEvent) => {
      if (e.key === watchKey) callback(e.newValue)
    }
    window.addEventListener('storage', handler)
    return () => {
      window.removeEventListener('storage', handler)
    }
  }
}

// 缓存实例
export const cacheStore = new CacheStorageProxy(CACHE_PREFIX)
